import { FC, ReactNode, useRef } from "react";
import { Box, Skeleton, Stack } from "@mui/material";
import { DataGridProps } from "@mui/x-data-grid";
import PaperCard from "../../../widgets/PaperCard";
import PaperCardHeader from "../../../widgets/PaperCard/PaperCardHeader";
import ServerDataGrid from "./ServerDataGrid";

type Props = DataGridProps & {
	title?: string;
	isLoading?: boolean;
	onReload?: VoidFunction;
	actions?: ReactNode;
	skeletonHeight?: number | string;
};

const ServerTable: FC<Props> = ({ title, isLoading, onReload, actions, skeletonHeight = 400, ...gridProps }) => {
	const containerRef = useRef<HTMLDivElement | null>(null);

	if (isLoading) {
		return <Skeleton variant="rounded" height={skeletonHeight} width="100%" />;
	}

	return (
		<PaperCard
			ref={containerRef}
			header={
				title || onReload ? (
					<PaperCardHeader
						containerRef={containerRef}
						title={title}
						isLoading={isLoading}
						onReload={onReload}
					/>
				) : null
			}
			content={
				<Stack direction="column" height="100%" width="100%">
					{actions ? <Box>{actions}</Box> : null}

					<Box sx={{ flex: 1, minHeight: 0, width: "100%" }}>
						<ServerDataGrid {...gridProps} />
					</Box>
				</Stack>
			}
			sxContent={{
				paddingRight: 0,
				paddingLeft: 0,
				paddingBottom: 0,
			}}
		/>
	);
};

export default ServerTable;
